import { routes } from './routes-generated';

import { GetWithHook, GetWithPromise, PostWithPromise } from '../modules/api/client';

export function Language2EndpointGetHook(
    param_text: string, 
    param_language: string, 
) {
    return GetWithHook(routes.Language, {
        text: param_text, 
        language: param_language, 
    });
}

export function Language2EndpointGetPromise(
    param_text: string, 
    param_language: string, 
) {
    return GetWithPromise(routes.Language, {
        text: param_text, 
        language: param_language, 
    });
}

export function Language2EndpointPostPromise(
    param_language: string, 
) {
    return PostWithPromise(routes.LanguagePost, {
        language: param_language, 
    });
}

